import { SessionStatus } from './types'

export const LIVE_SESSION_STATUSES: readonly SessionStatus[] = [
  SessionStatus.RUNNING,
  SessionStatus.RESUMABLE,
]
